export class ContentMyDelta {
  idadvisioriesViewAllLink: any;
  id: any;
  label: any;
  myFlightLabel: any;
  dashboardLabel: any;
  profileLabel: any;
  todayLabel: any;
  feed: any;
  skymilesLabel: any;
  mySkyMilesLabel: any;
  mySkyMilesUrl: any;
  newMySkyMilesUrl: any;
  availableMilesLabel: any;
  milesNeverExpire: any;
  medellionStatusDisclaimer: any;
  mqmLabel: any;
  mqsLabel: any;
  mqdLabel: any;
  cardSpendLabel: any;
  mqdWaiver: any;
  medellionStatusDisclaimer2: any;
  logoutLabel: any;
  logoutUrl: any;
  cardSpendAccessibility: any;
  currencySymbol: any;
  goTo: any;
  miles: any;
  mqdAccessibilityLabel: any;
  mqmAccessibilityLabel: any;
  mqsAccessibilityLabel: any;
  segments: any;
  skymilesMember: any;
  thankYouMessage: any;
  thankYouMessageMember: any;
  to: any;
  status: any;
  medallion: MedallionLevel[];
  waiver: Waiver[];
  salutation: Salutation[];
  myFlightCaretUrl: any;
  dashboardUrl: any;
  profileUrl: any;
  myFlightCaretOpenNewTab: any;
  isDelta: any;
  sinceLabel: any;
  accountDetails: any;
  silverThreshold: any;
  goldThreshold: any;
  redToSilverMsg: any;
  retainSilverMsg: any;
  silverToGoldMsg: any;
  retainGoldMsg: any;
  achivedGoldMsg: any;
  expirationDate: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['myFlightLabel']) {
        this.myFlightLabel = contentjson['myFlightLabel'];
      }
      if (contentjson['myFlightCaretUrl']) {
        this.myFlightCaretUrl = contentjson['myFlightCaretUrl'];
      }
      if (contentjson['dashboardLabel']) {
        this.dashboardLabel = contentjson['dashboardLabel'];
      }
      if (contentjson['dashboardUrl']) {
        this.dashboardUrl = contentjson['dashboardUrl'];
      }
      if (contentjson['profileLabel']) {
        this.profileLabel = contentjson['profileLabel'];
      }
      if (contentjson['profileUrl']) {
        this.profileUrl = contentjson['profileUrl'];
      }
      if (contentjson['mySkyMilesUrl']) {
        this.mySkyMilesUrl = contentjson['mySkyMilesUrl'];
      }
      if (contentjson['newMySkyMilesUrl']) {
        this.newMySkyMilesUrl = contentjson['newMySkyMilesUrl'];
      }
      if (contentjson['myFlightCaretOpenNewTab']) {
        this.myFlightCaretOpenNewTab = contentjson['myFlightCaretOpenNewTab'];
      }
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      if (contentjson['todayLabel']) {
        this.todayLabel = contentjson['todayLabel'];
      }
      if (contentjson['skymilesLabel']) {
        this.skymilesLabel = contentjson['skymilesLabel'];
      }
      if (contentjson['mySkyMilesLabel']) {
        this.mySkyMilesLabel = contentjson['mySkyMilesLabel'];
      }
      if (contentjson['feed']) {
        this.feed = contentjson['feed'];
      }
      if (contentjson['milesNeverExpire']) {
        this.milesNeverExpire = contentjson['milesNeverExpire'];
      } else {
        this.milesNeverExpire = '';
      }
      if (contentjson['availableMilesLabel']) {
        this.availableMilesLabel = contentjson['availableMilesLabel'];
      } else {
        this.availableMilesLabel = '';
      }
      if (contentjson['medellionStatusDisclaimer']) {
        this.medellionStatusDisclaimer =
          contentjson['medellionStatusDisclaimer'];
      } else {
        this.medellionStatusDisclaimer = '';
      }
      if (contentjson['mqmLabel']) {
        this.mqmLabel = contentjson['mqmLabel'];
      } else {
        this.mqmLabel = '';
      }
      if (contentjson['mqsLabel']) {
        this.mqsLabel = contentjson['mqsLabel'];
      } else {
        this.mqsLabel = '';
      }
      if (contentjson['mqdLabel']) {
        this.mqdLabel = contentjson['mqdLabel'];
      } else {
        this.mqdLabel = '';
      }
      if (contentjson['cardSpendLabel']) {
        this.cardSpendLabel = contentjson['cardSpendLabel'];
      } else {
        this.cardSpendLabel = '';
      }
      if (contentjson['mqdWaiver']) {
        this.mqdWaiver = contentjson['mqdWaiver'];
      } else {
        this.mqdWaiver = '';
      }
      if (contentjson['medellionStatusDisclaimer2']) {
        this.medellionStatusDisclaimer2 =
          contentjson['medellionStatusDisclaimer2'];
      } else {
        this.medellionStatusDisclaimer2 = '';
      }
      if (contentjson['logoutLabel']) {
        this.logoutLabel = contentjson['logoutLabel'];
      } else {
        this.logoutLabel = '';
      }
      if (contentjson['logoutUrl']) {
        this.logoutUrl = contentjson['logoutUrl'];
      } else {
        this.logoutUrl = '';
      }
      if (contentjson['cardSpendAccessibility']) {
        this.cardSpendAccessibility = contentjson['cardSpendAccessibility'];
      } else {
        this.cardSpendAccessibility = '';
      }
      if (contentjson['currencySymbol']) {
        this.currencySymbol = contentjson['currencySymbol'];
      } else {
        this.currencySymbol = '';
      }
      if (contentjson['goTo']) {
        this.goTo = contentjson['goTo'];
      } else {
        this.goTo = '';
      }
      if (contentjson['miles']) {
        this.miles = contentjson['miles'];
      } else {
        this.miles = '';
      }
      if (contentjson['mqdAccessibilityLabel']) {
        this.mqdAccessibilityLabel = contentjson['mqdAccessibilityLabel'];
      } else {
        this.mqdAccessibilityLabel = '';
      }
      if (contentjson['mqmAccessibilityLabel']) {
        this.mqmAccessibilityLabel = contentjson['mqmAccessibilityLabel'];
      } else {
        this.mqmAccessibilityLabel = '';
      }
      if (contentjson['mqsAccessibilityLabel']) {
        this.mqsAccessibilityLabel = contentjson['mqsAccessibilityLabel'];
      } else {
        this.mqsAccessibilityLabel = '';
      }
      if (contentjson['segments']) {
        this.segments = contentjson['segments'];
      } else {
        this.segments = '';
      }
      if (contentjson['skymilesMember']) {
        this.skymilesMember = contentjson['skymilesMember'];
      } else {
        this.skymilesMember = '';
      }
      if (contentjson['thankYouMessage']) {
        this.thankYouMessage = contentjson['thankYouMessage'];
      } else {
        this.thankYouMessage = '';
      }
      if (contentjson['thankYouMessageMember']) {
        this.thankYouMessageMember = contentjson['thankYouMessageMember'];
      } else {
        this.thankYouMessageMember = '';
      }
      if (contentjson['to']) {
        this.to = contentjson['to'];
      } else {
        this.to = '';
      }
      if (contentjson['status']) {
        this.status = contentjson['status'];
      } else {
        this.status = 'Status:';
      }
      if (contentjson['medallion']) {
        this.medallion = this.fillTierLevels(contentjson['medallion']);
      } else {
        this.medallion = null;
      }
      if (contentjson['waiver']) {
        this.waiver = this.fillWaiver(contentjson['waiver']);
      } else {
        this.waiver = null;
      }
      if (contentjson['salutation']) {
        this.salutation = this.fillSalutation(contentjson['salutation']);
      } else {
        this.salutation = null;
      }
      if (contentjson['accountOverview']) {
        this.isDelta = contentjson['accountOverview'];
      } else {
        this.isDelta = 'true';
      }
      if (contentjson['sinceLabel']) {
        this.sinceLabel = contentjson['sinceLabel'];
      } else {
        this.sinceLabel = '';
      }
      if (contentjson['accountDetails']) {
        this.accountDetails = contentjson['accountDetails'];
      } else {
        this.accountDetails = '';
      }
      if (contentjson['silverThreshold']) {
        this.silverThreshold = contentjson['silverThreshold'];
      } else {
        this.silverThreshold = '0';
      }
      if (contentjson['goldThreshold']) {
        this.goldThreshold = contentjson['goldThreshold'];
      } else {
        this.goldThreshold = '0';
      }
      if (contentjson['redToSilverMsg']) {
        this.redToSilverMsg = contentjson['redToSilverMsg'];
      } else {
        this.redToSilverMsg = '';
      }
      if (contentjson['retainSilverMsg']) {
        this.retainSilverMsg = contentjson['retainSilverMsg'];
      } else {
        this.retainSilverMsg = '';
      }
      if (contentjson['silverToGoldMsg']) {
        this.silverToGoldMsg = contentjson['silverToGoldMsg'];
      } else {
        this.silverToGoldMsg = '';
      }
      if (contentjson['retainGoldMsg']) {
        this.retainGoldMsg = contentjson['retainGoldMsg'];
      } else {
        this.retainGoldMsg = '';
      }
      if (contentjson['achivedGoldMsg']) {
        this.achivedGoldMsg = contentjson['achivedGoldMsg'];
      } else {
        this.achivedGoldMsg = '';
      }
      if (contentjson['expirationDate']) {
        this.expirationDate = contentjson['expirationDate'];
      } else {
        this.expirationDate = '';
      }
    }
  }

  private fillTierLevels(contentjson?: any): MedallionLevel[] {
    let tierlevel: MedallionLevel[] = [];
    const items = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      let counter = 1;
      for (const value of values) {
        items.set(counter, new MedallionLevel(value));
        counter++;
      }
      tierlevel = Array.from(items.values());
    }
    return tierlevel;
  }

  private fillWaiver(contentjson?: any): Waiver[] {
    let waiver: Waiver[] = [];
    const items = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      let counter = 1;
      for (const value of values) {
        items.set(counter, new Waiver(value));
        counter++;
      }
      waiver = Array.from(items.values());
    }
    return waiver;
  }

  private fillSalutation(contentjson?: any): Salutation[] {
    let salute: Salutation[] = [];
    const items = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      let counter = 1;
      for (const value of values) {
        items.set(counter, new Salutation(value));
        counter++;
      }
      salute = Array.from(items.values());
    }
    return salute;
  }
}

export class MedallionLevel {
  medallionId: any;
  medallionLabel: any;
  medallionUrl: any;
  medallionMessage: any;
  tierPointDescription: any;
  tierPointUrl: any;
  medallionDescription: any;

  constructor(tierlevel?: any) {
    if (tierlevel) {
      if (tierlevel['medallionId']) {
        this.medallionId = tierlevel['medallionId'];
      }
      if (tierlevel['medallionLabel']) {
        this.medallionLabel = tierlevel['medallionLabel'];
      }
      if (tierlevel['medallionUrl']) {
        this.medallionUrl = tierlevel['medallionUrl'];
      } else {
        this.medallionUrl = '';
      }
      if (tierlevel['medallionMessage']) {
        this.medallionMessage = tierlevel['medallionMessage'];
      } else {
        this.medallionMessage = '';
      }
      if (tierlevel['tierPointDescription']) {
        this.tierPointDescription = tierlevel['tierPointDescription'];
      } else {
        this.tierPointDescription = '';
      }
      if (tierlevel['medallionDescription']) {
        this.medallionDescription = tierlevel['medallionDescription'];
      } else {
        this.medallionDescription = '';
      }
      if (tierlevel['tierPointUrl']) {
        this.tierPointUrl = tierlevel['tierPointUrl'];
      } else {
        this.tierPointUrl = '';
      }
    }
  }
}

export class Salutation {
  salutationId: any;
  salutationLabel: any;

  constructor(salute?: any) {
    if (salute) {
      if (salute['salutationId']) {
        this.salutationId = salute['salutationId'];
      }
      if (salute['salutationLabel']) {
        this.salutationLabel = salute['salutationLabel'];
      }
    }
  }
}

export class Waiver {
  waiverLabel: any;
  waiverUrl: any;
  waiverPrice: any;

  constructor(tierlevel?: any) {
    if (tierlevel) {
      if (tierlevel['waiverLabel']) {
        this.waiverLabel = tierlevel['waiverLabel'];
      } else {
        this.waiverLabel = null;
      }
      if (tierlevel['waiverUrl']) {
        this.waiverUrl = tierlevel['waiverUrl'];
      } else {
        this.waiverUrl = '';
      }
      if (tierlevel['waiverPrice']) {
        this.waiverPrice = tierlevel['waiverPrice'];
      } else {
        this.waiverPrice = '25K';
      }
    }
  }
}
